import React from 'react';
import Grid from './Grid.jsx';

class Estoque extends React.Component {

    constructor() {

        super();

        this.state = {
            gridHeader: [ "Centro" ],
            centros: []
        };

    }

    componentDidMount() {

        if (localStorage.roleEstoque === "nenhuma") {
            window.location.href = "/home";
        }

        fetch("/api/centro/grid2", {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            if (JSON.parse(localStorage.usuarioInfo).restrito_centro) {

                let cId = JSON.parse(localStorage.usuarioInfo).centro_id;

                for (let i = 0; i < responseJson.length; i++) {

                    if (responseJson[i].id === cId) {
                        this.setState({ centros: [ responseJson[i] ] });
                        break;
                    }

                }

            } else {

                this.setState({ centros: responseJson });

            }

        });

    }

    render() {
        return(
            <div>
                <h1 id="estoque-title">Estoque</h1><br />
                <p id="estoque-txt">
                    Escolha um centro para verificar o seu estoque.
                </p><br />
                <Grid key={ this.state.centros }
                    header={ this.state.gridHeader }
                    data={ this.state.centros }
                    pageSize={ 10 }
                    gridWidth={ "600px" }
                    linkTo={ "/estoquecentro" } />
            </div>
        );
    }

}

export default Estoque;

